/* unplugin-vue-components disabled */import { render } from "./TextLogicalReasoningQuestionSelector.vue?vue&type=template&id=719e6bfb&scoped=true"
import script from "./TextLogicalReasoningQuestionSelector.vue?vue&type=script&lang=js"
export * from "./TextLogicalReasoningQuestionSelector.vue?vue&type=script&lang=js"

import "./TextLogicalReasoningQuestionSelector.vue?vue&type=style&index=0&id=719e6bfb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719e6bfb"]])

export default __exports__